import React from "react"
import { Box } from "@infotech/uikit-grid"
import cn from "classnames"
import styles from "./styles.css"

const NewPlanConstraint = ({ isPlan }) => (
  <Box loose flex column className={styles.NewPlanConstraintWrapper} pt="3md">
    <Box
      loose
      className={cn(
        styles.NewPlanConstraintText,
        styles.NewPlanConstraintTitle,
      )}
    >
      Начало работы с ограничениями
    </Box>
    <Box
      loose
      pt="1md"
      className={cn(styles.NewPlanConstraintText, styles.NewPlanConstraintBody)}
    >
      Ограничения — это правила и условия, которым должен соответствовать план,
      а также его ресурсы и события.
    </Box>
    <Box
      loose
      pt="3md"
      className={cn(
        styles.NewPlanConstraintText,
        styles.NewPlanConstraintFooter,
      )}
    >
      Для добавления ограничений создайте
      {/* eslint-disable-next-line react/no-unescaped-entities */}
      {isPlan ? ` план ` : ` тип плана`} на вкладке "Общая информация".
    </Box>
  </Box>
)

export default NewPlanConstraint
